import { Button, Input } from "@rumbledirect/ui";
import { Alert, Form, FormInstance } from "antd";
import { useEffect, useState } from "react";
import slugify from "slugify";

interface AffiliateCreateSlugStepProps {
  form: FormInstance;
  loading?: boolean;
}

export const AffiliateCreateSlugStep = ({
  form,
  loading,
}: AffiliateCreateSlugStepProps) => {
  // Keep track of the last generated slug to prevent auto generating when user has edited slug
  const [generatedSlug, setGeneratedSlug] = useState<string | null>(null);

  const handleRegenerate = () => {
    const name: string = form.getFieldValue("name");
    if (!name) return;
    const slug = slugify(name, { lower: true });
    form.setFieldsValue({ slug });
    setGeneratedSlug(slug);
  };

  useEffect(() => {
    const name: string = form.getFieldValue("name");
    const currentSlug: string = form.getFieldValue("slug");
    if (name && (!currentSlug || currentSlug === generatedSlug)) {
      const slug = slugify(name, { lower: true });
      form.setFieldsValue({ slug: slug });
      setGeneratedSlug(slug);
    }
  }, [form, generatedSlug]);

  return (
    <div>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message={
          <span>
            De slug wordt gebruikt als unieke identifier. Pas alleen aan indien
            nodig.
          </span>
        }
      />
      <Form.Item
        name="slug"
        label="Slug"
        rules={[{ required: true, message: "Slug is verplicht" }]}
      >
        <Input
          placeholder="automatisch gegenereerd"
          disabled={loading}
          addonAfter={
            <Button
              type="link"
              onClick={handleRegenerate}
              style={{ padding: 0 }}
            >
              Genereer opnieuw
            </Button>
          }
        />
      </Form.Item>
    </div>
  );
};
